// hooks/useDragScroll.js
import { useRef, useCallback } from 'react';

/**
 * Хук для горизонтального перетягування таблиці мишею / пальцем.
 * Повертає ref, який треба повісити на scrollable-контейнер.
 */
export const useDragScroll = () => {
  const ref = useRef(null);
  const state = useRef({ isDown: false, startX: 0, scrollLeft: 0 });

  const onMouseDown = useCallback((e) => {
    // Ігноруємо кліки по інтерактивних елементах
    if (e.target.closest('input,button,a,select')) return;
    const el = ref.current;
    if (!el) return;
    state.current = { isDown: true, startX: e.pageX - el.offsetLeft, scrollLeft: el.scrollLeft };
    el.style.cursor = 'grabbing';
    el.style.userSelect = 'none';
  }, []);

  const onMouseLeave = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    state.current.isDown = false;
    el.style.cursor = '';
    el.style.userSelect = '';
  }, []);

  const onMouseUp = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    state.current.isDown = false;
    el.style.cursor = '';
    el.style.userSelect = '';
  }, []);

  const onMouseMove = useCallback((e) => {
    if (!state.current.isDown) return;
    e.preventDefault();
    const el = ref.current;
    if (!el) return;
    const x = e.pageX - el.offsetLeft;
    const walk = (x - state.current.startX) * 1.2;
    el.scrollLeft = state.current.scrollLeft - walk;
  }, []);

  const listeners = { onMouseDown, onMouseLeave, onMouseUp, onMouseMove };

  return { ref, listeners };
};